const state = {
  access_token: localStorage.getItem("access_token") || ""
};

const getters = {
  getAccessToken: () => state.access_token,
  hasAccessToken: () => !!state.access_token
};

const actions = {};

const mutations = {
  setAccessToken(state, payload) {
    state.access_token = payload;
  },
  removeAccessToken(state) {
    state.access_token = "";
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
